/**
 * Catppuccin palette (https://catppuccin.com). Light = Latte, dark = Mocha.
 * Mapped onto `--nf-*` design tokens by the web SPA (web/src/styles.ts).
 * The browser extension declares the same palette values in popup.css.
 */
export const catppuccin = {
  latte: {
    base: "#eff1f5",
    mantle: "#e6e9ef",
    surface0: "#ccd0da",
    surface1: "#bcc0cc",
    text: "#4c4f69",
    subtext0: "#6c6f85",
    red: "#d20f39",
    green: "#40a02b",
    peach: "#fe640b",
    mauve: "#8839ef",
  },
  mocha: {
    base: "#1e1e2e",
    mantle: "#181825",
    surface0: "#313244",
    surface1: "#45475a",
    text: "#cdd6f4",
    subtext0: "#a6adc8",
    red: "#f38ba8",
    green: "#a6e3a1",
    peach: "#fab387",
    mauve: "#cba6f7",
  },
} as const;
